module.exports = __webpack_public_path__ + "static/media/sign-up-today.1044712d.png";